import { styled } from '@linaria/react';

import { InfoLabel } from '../shared-styles';

export const BookmakersLabel = styled.div`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  line-height: 15px;
  padding-top: 12px;
  color: var(--oc-text-subtext);
  white-space: nowrap;
  text-align: left;
  box-sizing: border-box;
  overflow: visible;
  position: relative;

  & ${InfoLabel} {
    font-weight: 800;
    white-space: nowrap;
    color: var(--oc-text-subtext);
  }
`;

export const OffersLegend = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 1;

  &.not-supported {
    opacity: 0;
  }
`;

export const OffersLegendItem = styled.div`
  display: flex;
  align-items: center;
  height: 23px;
`;

export const QuickBetWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const QuickBetTooltipDisclosure = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  &:hover {
    cursor: pointer;
  }
`;

export const QuickBetText = styled.p`
  color: var(--oc-text-subtext);
  line-height: 15px;
  margin: 0 3px;
  user-select: none;
`;
